export default __webpack_public_path__ + "36a4975bc7b18088c8dec9fbc887a6d1.svg";